// extracted by mini-css-extract-plugin
export default {"card-container":"style_card-container__amsJG"};